import { OPEN_PRICE_ITEM_DISPLAY } from '../VNItems/consts'

export const isOpenPriceItem = (item) => item.defaultPriceInCents === null

/**
 * Display price for an item based on its properties and cart quantity
 *
 * @param {Object} item
 * @param {Number} cartQuantity
 * @returns {String}
 */
export const getDisplayPrice = (item, cartQuantity) => {
  const displayPrice = item.price

  if (item.price === '--') {
    return OPEN_PRICE_ITEM_DISPLAY
  }

  if (cartQuantity === item.orderMaxAmount) {
    return 'MAX REACHED'
  }

  if (item.variants?.[0]?.inventoryState === 'unavailable') {
    return 'SOLD OUT'
  }

  if (item.inventory && item.inventory <= 10) {
    return `${displayPrice} - ${item.inventory} LEFT!`
  }

  return displayPrice
}
